// src/components/LoadingSpinner.js
import React from 'react';
import Lottie from 'react-lottie';
import animationData from './loadingAnimation.json'; // Ensure this JSON file is in the same directory
import './LoadingSpinner.css';

const LoadingSpinner = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <div className="loading-spinner">
      <Lottie options={defaultOptions} height={100} width={100} />
    </div>
  );
};

export default LoadingSpinner;
